import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import SignIn from './components/pages/SignIn';
import SignUp from './components/pages/SignUp';
import InspectionDetail from './components/pages/upgrade/InspectionDetail/InspectionDetailPage';
import LicenceAgreement from './components/pages/LicenceAgreement';
import ServiceProviderManagement from './components/pages/ServiceProviderManagement';
import AddServiceProvider from './components/pages/AddServiceProvider';
import EditServiceProvider from './components/pages/EditServiceProvider';
import InspectionExport from './components/pages/InspectionExport';
import NotFound from './components/pages/NotFound';

import AppContainer from './components/modules/AppContainer';
import AuthorisedRoute from './components/modules/ProtectedRoutes/AuthenticatedRoute';
import PlatformAdminRoute from './components/modules/ProtectedRoutes/PlatformAdminRoute';
import TeamManagement from './components/pages/upgrade/TeamManagement/TeamManagement';
import OrganisationProfileWrapper from './components/pages/upgrade/OrganisationProfile/OrganisationProfileWrapper';
import FragmentSupportingSwitch from './components/modules/Routing/FragmentSupportingSwitch';
import ScrollToTopOnNavigate from './components/modules/Routing/ScrollToTopOnNavigate';
import InspectionListingPage from './components/pages/upgrade/InspectionListing/InspectionListingPage';
import InspectionDetailShare from './components/pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShare';
import RemoteSubmissionPage from './components/pages/RemoteSubmission/RemoteSubmissionPage';

export default () => {
    return (
        <AppContainer>
            <ScrollToTopOnNavigate />
            <FragmentSupportingSwitch>
                <Route exact path="/" render={() => <Redirect to="/sign-in" />} />
                <Route exact path="/sign-in" component={SignIn} />
                <Route exact path="/account/invite/:token" component={SignUp} />
                <Route
                    exact
                    path="/remote-submission/:token"
                    component={RemoteSubmissionPage}
                />
                <Route
                    exact
                    path="/share/:token"
                    component={InspectionDetailShare}
                />
                <Route
                    exact
                    path="/inspections/:id/export/:token"
                    render={(props) => (
                        <InspectionExport {...props} isNewDesign />
                    )}
                />

                {
                    ["/inspections", "/inspections/:scope/:status"].map((path) => <AuthorisedRoute
                        exact
                        key={path}
                        path={path}
                        component={InspectionListingPage}
                    />)
                }
                <AuthorisedRoute
                    exact
                    path="/inspections/:id"
                    component={InspectionDetail}
                />
                <AuthorisedRoute exact path="/settings/organisation-profile/general" component={OrganisationProfileWrapper}/>
                <AuthorisedRoute exact path="/settings/team-management" component={TeamManagement} />
                <AuthorisedRoute
                    exact
                    path="/licence-agreement"
                    component={LicenceAgreement}
                />
                <PlatformAdminRoute
                    exact
                    path="/platform-admin"
                    component={ServiceProviderManagement}
                />
                <PlatformAdminRoute
                    exact
                    path="/platform-admin/service-providers"
                    component={AddServiceProvider}
                />
                <PlatformAdminRoute
                    exact
                    path="/platform-admin/service-providers/:id"
                    component={EditServiceProvider}
                />
                <Route exact path="/not-found" component={NotFound} />
                <Route path="*" render={() => <Redirect to="/not-found" />} />
            </FragmentSupportingSwitch>
        </AppContainer>
    );
};
